package us.laantech.laanmanage.feature.login

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.material3.*
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import kotlinx.coroutines.launch
import us.laantech.laanmanage.ENV
import us.laantech.common.api.KtorClient
import us.laantech.laanmanage.api.startOAuthLogin


@Composable
fun LoginView(
    modifier: Modifier = Modifier,
) {
    val scope = rememberCoroutineScope()

    val gradientColors = listOf(
        Color(13, 53, 95),
        Color(13, 53, 95)
    )

    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center,
        modifier = modifier
            .fillMaxSize()
            .background(brush = Brush.verticalGradient(colors = gradientColors))
    ) {
        Text(
            text = "LAAN Backoffice",
            style = MaterialTheme.typography.headlineLarge,
            color = Color(255, 255, 255),
            modifier = Modifier.padding(bottom = 16.dp)
        )

        Button(
            onClick = {
                scope.launch {
                    val code = startOAuthLogin()
                    if (code != null) {
                        // Flips KtorClient.authState → true, which drives the recompose
                        // to the main UI (collected in AppViewModel).
                        KtorClient.instance.exchangeCodeForTokens(
                            authorizationCode = code,
                            redirectUri = ENV.COGNITO_IOS_CALLBACK_URL,
                        )
                    }
                }
            },
            modifier = Modifier.padding(16.dp)
        ) {
            Text(
                "Login",
                style = MaterialTheme.typography.headlineSmall
            )
        }
    }
}
